<section class="has-padding-block-6 animated fadeIn" >
  <div class="row">
    <div class="col-md-7">
      <h2 class="section-title">Root Rewards Program</h2>
      <p>As a Roots Rewards member, you’ll enjoy lots of benefits while also helping us reach our business
        goals and create a better local food system for the greater Philadelphia region.</p>
    </div>
    <div class="col-md-5">
      <img src="../../../assets/images/landing/roots-rewards/roots-rewards-1.webp" class="img-side is-height-3" alt="Root Rewards Program image">
    </div>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">Membership Perks</h2>
    <ul class="ul-checklist--circle is-hor">
      <li>Lower order minimum of $20</li>
      <li>Free home delivery</li>
      <li>20% off Frequent Shopper Coupons for every 10 orders placed</li>
    </ul>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">Costs and Charges</h2>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="ul-icon-list">
          <span class="list-icon material-symbols-outlined">sell</span>
          <div class="list-content">$15 monthly membership fee billed when you sign-up and then recurring on the same date each month.
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="ul-icon-list">
          <span class="list-icon material-symbols-outlined">credit_card</span>
          <div class="list-content">You can choose to add an OPTIONAL CSA deposit, which will remain on your account and be used by Philly Foodworks and our network of small producers to support the growth and development of our local food system*.
            <br>
            <a routerLink="/pages/about-us/support" class="link-primary">Learn more about our impact</a>
          </div>

        </div>
      </div>
    </div>
    @if (membershipRouterLink()) {  
      <div class="btn-wrap is-center">
        <a class="btn btn-secondary" [routerLink]='membershipRouterLink()'>Add your Roots Rewards membership now</a>
      </div>
    }
    <small>*These deposits can be refunded to you at any time. Reach out by phone or email and we will refund you.</small>
  </div>
  <hr class="is-thick">
  <div class="has-padding-block-3">
    <img src="../../../assets/images/landing/roots-rewards/roots-rewards-2.webp" class="img-fluid" alt="Roots Rewards membership now - banner image"/>
  </div>
  <div>
    <h2 class="section-title">How your membership helps further our mission</h2>
    <ul class="ul-checklist--circle is-col-2">
      <li>CSA deposits from Roots Rewards members allow us the working capital to finance small equipment upgrades, farmer education, and other expenses that will greatly benefit our network of local, family farms.</li>
      <li>Membership fees go toward supporting our marketing efforts, which increases our reach and allows us to include more local producers in our online store.</li>
    </ul>
  </div>
  <div>
    <h2 class="section-title">More ways to support the local food system</h2>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">sync</span>
      <div class="list-content">
        <h3 class="list-title">Add a recurring donation</h3>
        <p>You can add recurring donations to your account through your shopping cart. Donations help support our efforts to increase access to local food.</p>
        <a routerLink="/pages/about-us/donations">Click here to learn about our food access efforts.</a>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">percent</span>
      <div class="list-content">
        <h3 class="list-title">Increase your CSA deposit amount</h3>
        <p>If you are able, when you increase your CSA deposit amount it allows us to support more local farms and local food businesses.</p>
      </div>
    </div>
  </div>
</section>
